export default __webpack_public_path__ + "static/media/template1.1a8afc58.png";